import { render, staticRenderFns } from "./GoogleCallBack.vue?vue&type=template&id=53561bd3&"
import script from "./GoogleCallBack.vue?vue&type=script&lang=js&"
export * from "./GoogleCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports